import { isNil } from "lodash";
import * as imageSelectors from "../images/selectors";

export function getDeviceById(entities, deviceId) {
    const { devices } = entities;
    if (isNil(devices)) {
        return null;
    }
    const device = devices[deviceId];
    if (!device) {
        return null;
    }
    return {
        ...device,
        iconImage: imageSelectors.getImageById(entities, device.iconImage)
    };
}



// WEBPACK FOOTER //
// ./src/modules/devices/selectors.js